import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import { FindRecipientInfoType } from 'owa-recipient-common/lib/components/FindRecipientInfo';
import { action } from 'satcheljs/lib/legacy';

export default action('shiftFindResultHighlightIndex')(function shiftFindResultHighlightIndex(
    recipientWell: RecipientWellWithFindControlViewState,
    isIncrement: boolean,
    infoType: FindRecipientInfoType
) {
    // Only shift highlight index when find result is visible
    if (recipientWell.shouldShowFindResult) {
        let findResultCount = recipientWell.findResultSet.length;
        if (isIncrement) {
            recipientWell.findResultHightlightIndex++;
        } else {
            recipientWell.findResultHightlightIndex--;
        }
        // Incrementing on last item loops back to the first item.
        // Decrementing on first item loops back to the last item.
        let totalOptions =
            findResultCount +
            (infoType === FindRecipientInfoType.SearchDirectory ||
            infoType === FindRecipientInfoType.UseAddress
                ? 1
                : 0);
        recipientWell.findResultHightlightIndex =
            (recipientWell.findResultHightlightIndex + totalOptions) % totalOptions;
    }
});
